import { Box, List, useTheme } from '@mui/material';
import SidebarItem from 'components/Layouts/components/SidebarItem';
import { knowledgeBase } from 'routes/config';
import { Outlet } from 'react-router-dom';
import { FiDatabase } from 'react-icons/fi';
import { FiBox } from 'react-icons/fi';

export default function KnowledgeBase() {
  const theme = useTheme();
  return (
    <>
      <Box display='flex' gap={4} minHeight='100vh'>
        <List
          sx={{
            minWidth: 262,
            maxWidth: 262,
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: 1,
            position: 'sticky',
            top: '270px'
          }}
        >
          <SidebarItem to={knowledgeBase.dataset} icon={<FiDatabase />} label='Dataset' />

          <SidebarItem to={knowledgeBase.retrievalTesting} icon={<FiBox />} label='Retrieval Testing' />
        </List>
        <Box width='100%' paddingBottom='100px'>
          <Outlet />
        </Box>
      </Box>
    </>
  );
}
